import styled from 'styled-components';

export const AppStyled = styled.div`
  height: 100vh;
`;
